import { render, staticRenderFns } from "./OrderRelated.vue?vue&type=template&id=b74b49ca&scoped=true"
import script from "./OrderRelated.vue?vue&type=script&lang=js"
export * from "./OrderRelated.vue?vue&type=script&lang=js"
import style0 from "./OrderRelated.vue?vue&type=style&index=0&id=b74b49ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74b49ca",
  null
  
)

export default component.exports